import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TitleCasePipe } from '@angular/common';

import { PartialsModule } from './../../shared/partials/partials.module';
import { SignUpRoutingModule } from './sign-up-routing.module';
import { RegistrationErrorsComponent } from '../../../shared/components/registration-errors/registration-errors.component';

import { SignupComponent } from './signup/signup.component';
import { CompanyComponent } from './company/company.component';
import { InviteComponent } from './invite/invite.component';
import { SelectPlanComponent } from './select-plan/select-plan.component';
import { CoreModule } from '@core/core.module';
import { RedeemComponent } from './redeem/redeem.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { ProfileCompletionComponent } from './profile-completion/profile-completion.component';
import { QuickSignupComponent } from './quick-signup/quick-signup.component';
import { ScanningConfigComponent } from './scanning-config/scanning-config.component';
import { SuccessComponent } from './success/success.component';
import { CheckoutSuccessComponent } from '@dashboard/pages/company/checkout-success/checkout-success.component';

// so register -> company information -> trial / sign up for a plan  ->  invite users
@NgModule({
  declarations: [
    SignupComponent,
    CompanyComponent,
    InviteComponent,
    SelectPlanComponent,
    RedeemComponent,
    UnsubscribeComponent,
    ProfileCompletionComponent,
    QuickSignupComponent,
    CheckoutSuccessComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    SignUpRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    PartialsModule,
    TitleCasePipe,
    RegistrationErrorsComponent,
    ScanningConfigComponent,
    SuccessComponent,
  ],
})
export class SignUpModule {}
